import {
  DataType,
  FormField,
} from '@labrav/react-components/lib/@types/types/forms'

export const opportunityTypeOptions = [
  'Expansion',
  'Flat Renewal',
  'Net New Business',
]
export const useCaseOptions = [
  'AI Machine Learning and Analytics',
  'Archiving',
  'Big Data: Data Warehouse / Data Integration / ETL / Data Lake / BI',
  'Blockchain',
  'Business Applications & Contact Center',
  'Business Applications & SAP Production',
  'Business Applications: Mainframe Modernization',
  'Centralized Operations Management',
  'Cloud Management Tools',
  'Cloud Management Tools & DevOps with Continuous Integration & Continuous Delivery (CICD)',
  'Configuration, Compliance & Auditing',
  'Connected Services',
  'Containers & Serverless',
  'Content Delivery & Edge Services',
  'Database',
  'Edge Computing / End User Computing',
  'Energy',
  'Enterprise Governance & Controls',
  'Enterprise Resource Planning',
  'Financial Services',
  'Healthcare and Life Sciences',
  'High Performance Computing',
  'Hybrid Application Platform',
  'Industrial Software',
  'IOT',
  'Manufacturing, Supply Chain and Operations',
  'Media & High performance computing (HPC)',
  'Migration / Database Migration',
  'Monitoring & Observability',
  'Monitoring, logging and performance',
  'Networking',
  'Outpost',
  'SAP',
  'Security & Compliance',
  'Storage & Backup',
  'Training',
  'VMC',
  'VMWare',
  'Web development & DevOps',
]

export const apnProgramOptions = [
  'APN Immersion Days',
  'APN Solution Space',
  'ATO (Authority to Operate)',
  'AWS Marketplace Campaign',
  'ISV Immersion Day SFID Program',
  'ISV Workload Migration',
  'Migration Acceleration Program (MAP)',
  'P3',
  'Partner Launch Initiative',
  'Partner Opportunity Acceleration Funded',
  'The Next Smart',
  'VMware Cloud on AWS',
  'Well-Architected',
  'Windows',
  'Workspaces/AppStream Accelerator Program',
  'WWPS NDPP',
]

export const deliveryModelOptions = [
  'BYOL or AMI',
  'Managed Services',
  'Professional Services',
  'Resell',
  'SaaS or PaaS',
  'Other',
]

export const partnerPrimaryNeedFromAWSOptions = [
  'Co-Sell - Architectural Validation',
  'Co-Sell - Business Presentation',
  'Co-Sell - Competitive Information',
  'Co-Sell - Deal Support',
  'Co-Sell - Pricing Assistance',
  'Co-Sell - Support for Public Tender / RFx',
  'Co-Sell - Technical Consultation',
  'Co-Sell - Total Cost of Ownership Evaluation',
  'Do Not Need Support from AWS Sales Rep',
]

export const salesActivitiesOptions = [
  'Agreed on solution to Business Problem',
  'Completed Action Plan',
  'Conducted POC / Demo',
  'Customer has shown interest in solution',
  'Finalized Deployment Need',
  'In evaluation / planning stage',
  'Initialized discussions with customer',
  'SOW Signed',
]

export const referralStageOptions = [
  'Prospect',
  'Technical Validation',
  'Business Validation',
  'Committed',
  'Qualified',
  'Launched',
  'Closed Lost',
]

export const leadStageOptions = [
  'Open',
  'Research',
  'Disqualified',
  'Qualified',
]

/** Form field IDs that are read-only when referral is "Approved by AWS". */
export const fieldsToMakeReadOnlyWhenIsApprovedByAWS = [
  'companyName',
  'website',
  'country',
  'state',
  'postalCode',
  'partnerProjectTitle',
]

/** Form field IDs that are editable in "Launched" state for ISV partners. All others read-only. */
export const editableFieldsInLaunchedStateForISV = [
  'additionalComments',
  'currency',
  'customerSoftwareValue',
  'contractEffectiveDate',
  'contractExpirationDate',
  'procurementType',
]

/** Form field IDs that are editable in "Launched" state for Non-ISV partners. All others read-only. */
export const editableFieldsInLaunchedStateForNonISV = ['additionalComments']
export const rejectionReason: FormField = {
  title: 'Rejection reason',
  placeHolder: 'Select the rejection reason',
  id: 'rejectionReason',
  isRequired: false,
  humanReadableKey: 'rejectionReason',
  isReadOnly: false,
  isCustom: false,
  defaultValue: undefined,
  dataType: 'enum' as DataType,
  options: [
    'Customer problem unclear',
    'Duplicate of Partner Referral',
    'Next steps unclear',
    'Renewal opportunity',
    'Unable to support',
    'Other',
  ],
}
export const closedReasonOptions = [
  'Customer Deficiency',
  'Customer Experience',
  'Delay / Cancellation of Project',
  'Financial/Commercial',
  'Legal / Tax / Regulatory',
  'Lost to Competitor – Google',
  'Lost to Competitor – Microsoft',
  'Lost to Competitor – SoftLayer',
  'Lost to Competitor – VMWare',
  'Lost to Competitor – Other',
  'No Opportunity',
  'On Premises Deployment',
  'Partner Gap',
  'People/Relationship/Governance',
  'Price',
  'Product/Technology',
  'Security / Compliance',
  'Technical Limitations',
  'Other',
]
export const closedReasonOptionsField: FormField = {
  title: 'Closed reason',
  placeHolder: '',
  id: 'closedReason',
  isRequired: false,
  humanReadableKey: 'closedReason',
  isReadOnly: false,
  isCustom: false,
  defaultValue: undefined,
  dataType: 'enum',
  options: closedReasonOptions,
}

export const azureClosedReasonOptions = [
  'Customer did not have budget',
  'Customer / opportunity too small',
  'Customer did not respond',
  'Customer selected another vendor',
  'My solution or service is not a fit',
  'Not a customer',
  'Proposed timeline too short',
  'Report as abuse, spam, or phishing',
  'Other',
]

export const azureClosedReasonOptionsField: FormField = {
  title: 'Closed reason',
  placeHolder: '',
  id: 'closedReason',
  isRequired: false,
  humanReadableKey: 'closedReason',
  isReadOnly: false,
  isCustom: false,
  defaultValue: undefined,
  dataType: 'enum',
  options: azureClosedReasonOptions,
}

export const countryOptions = [
  'United States',
  'Afghanistan',
  'Aland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua And Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Cook Islands',
  'Costa Rica',
  "Cote d'Ivoire",
  'Croatia',
  'Cuba',
  'Curacao',
  'Cyprus',
  'Czech Republic',
  'Democratic Republic Of The Congo',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Great Britain',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran, Islamic Republic Of',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Korea',
  'Kuwait',
  'Kyrgyzstan',
  "Lao People's Democratic Republic",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libyan Arab Jamahiriya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'MACAO',
  'Macedonia, The former Yugoslav Republic Of',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova, Republic of',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'Netherlands Antilles',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestinian Territory, Occupied',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Reunion',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Barthelemy',
  'Saint Helena, Ascension and Tristan Da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French Part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch Part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Viet Nam',
  'VIRGIN ISLANDS, BRITISH',
  'VIRGIN ISLANDS, U.S.',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
]
export const stateOptions = [
  'Alabama',
  'Alaska',
  'American Samoa',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Dist. of Columbia',
  'Federated States of Micronesia',
  'Florida',
  'Georgia',
  'Guam',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Marshall Islands',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Palau',
  'Pennsylvania',
  'Puerto Rico',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Virgin Islands',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
  'APO/AE',
  'AFO/FPO',
  'FPO AP',
]
export const currencyOptions = [
  'USD',
  'EUR',
  'GBP',
  'AUD',
  'CAD',
  'CNY',
  'NZD',
  'INR',
  'JPY',
  'CHF',
  'SEK',
  'AED',
  'AFN',
  'ALL',
  'AMD',
  'ANG',
  'AOA',
  'ARS',
  'AWG',
  'AZN',
  'BAM',
  'BBD',
  'BDT',
  'BGN',
  'BHD',
  'BIF',
  'BMD',
  'BND',
  'BOB',
  'BOV',
  'BRL',
  'BSD',
  'BTN',
  'BWP',
  'BYN',
  'BZD',
  'CDF',
  'CHE',
  'CHW',
  'CLF',
  'CLP',
  'COP',
  'COU',
  'CRC',
  'CUC',
  'CUP',
  'CVE',
  'CZK',
  'DJF',
  'DKK',
  'DOP',
  'DZD',
  'EGP',
  'ERN',
  'ETB',
  'FJD',
  'FKP',
  'GEL',
  'GHS',
  'GIP',
  'GMD',
  'GNF',
  'GTQ',
  'GYD',
  'HKD',
  'HNL',
  'HRK',
  'HTG',
  'HUF',
  'IDR',
  'ILS',
  'IQD',
  'IRR',
  'ISK',
  'JMD',
  'JOD',
  'KES',
  'KGS',
  'KHR',
  'KMF',
  'KPW',
  'KRW',
  'KWD',
  'KYD',
  'KZT',
  'LAK',
  'LBP',
  'LKR',
  'LRD',
  'LSL',
  'LYD',
  'MAD',
  'MDL',
  'MGA',
  'MKD',
  'MMK',
  'MNT',
  'MOP',
  'MRU',
  'MUR',
  'MVR',
  'MWK',
  'MXN',
  'MXV',
  'MYR',
  'MZN',
  'NAD',
  'NGN',
  'NIO',
  'NOK',
  'NPR',
  'OMR',
  'PAB',
  'PEN',
  'PGK',
  'PHP',
  'PKR',
  'PLN',
  'PYG',
  'QAR',
  'RON',
  'RSD',
  'RUB',
  'RWF',
  'SAR',
  'SBD',
  'SCR',
  'SDG',
  'SGD',
  'SHP',
  'SLL',
  'SOS',
  'SRD',
  'SSP',
  'STN',
  'SVC',
  'SYP',
  'SZL',
  'THB',
  'TJS',
  'TMT',
  'TND',
  'TOP',
  'TRY',
  'TTD',
  'TWD',
  'TZS',
  'UAH',
  'UGX',
  'USN',
  'UYI',
  'UYU',
  'UZS',
  'VEF',
  'VND',
  'VUV',
  'WST',
  'XAF',
  'XCD',
  'XDR',
  'XOF',
  'XPF',
  'XSU',
  'XUA',
  'YER',
  'ZAR',
  'ZMW',
  'ZWL',
]

export const procurementTypesOptions = [
  'Contract',
  'Pay-as-you-go',
  'Subscription',
]

export const marketingActivityChannelOptions = [
  'AWS Marketing Central',
  'Content Syndication',
  'Display',
  'Email',
  'Live Event',
  'Out Of Home (OOH)',
  'Print',
  'Search',
  'Social',
  'Telemarketing',
  'TV',
  'Video',
  'Virtual Event',
]

export const marketingActivityUseCaseOptions = [
  'AI/ML',
  'Analytics',
  'Application Integration',
  'Blockchain',
  'Business Applications',
  'Cloud Financial Management',
  'Compute',
  'Containers',
  'Customer Engagement',
  'Databases',
  'Developer Tools',
  'End User Computing',
  'Front End Web & Mobile',
  'Game Tech',
  'IoT',
  'Management & Governance',
  'Media Services',
  'Migration & Transfer',
  'Networking & Content Delivery',
  'Quantum Technologies',
  'Robotics',
  'Satellite',
  'Security',
  'Serverless',
  'Storage',
  'VR & AR',
]

export const competitiveTrackingOptions = [
  'Akamai',
  'AliCloud',
  'Co-Location',
  'Google Cloud Platform',
  'IBM Softlayer',
  'Microsoft Azure',
  'No Competition',
  'On-Prem',
  'Oracle Cloud',
  'Other- Cost Optimization',
  'Other',
]

export const industryOptions = [
  'Aerospace',
  'Agriculture',
  'Automotive',
  'Computers & Electronics',
  'Consumer Goods',
  'Education',
  'Energy - Oil & Gas',
  'Energy - Power & Utilities',
  'Financial Services',
  'Gaming',
  'Government',
  'Healthcare',
  'Hospitality',
  'Life Sciences',
  'Manufacturing',
  'Marketing & Advertising',
  'Media & Entertainment',
  'Mining',
  'Non-Profit Organization',
  'Professional Services',
  'Real Estate & Construction',
  'Retail',
  'Software & Internet',
  'Telecommunications',
  'Transportation & Logistics',
  'Travel',
  'Wholesale & Distribution',
  'Other',
]

export const AWS_PARTNER_CENTRAL_FUNDING_BASE_URL =
  'https://us-east-1.console.aws.amazon.com/partnercentral/funding'
